import React from "react";
import "./App.css";
import chickkcheek from "./images/background.jpg";
import logo from "./images/logo1.png";
import { Image } from "react-bootstrap";
import { Divider } from "antd";
import ImgGrab from "../src/images/grab.png";
import ImgLineman from "../src/images/Lineman.png";
import ImgShopee from "../src/images/Shopee-food.png";
function App() {
  const links = [
    {
      label: "TikTok",
      url: "https://www.tiktok.com/@chickk.cheek?_t=8q6SoTEAKYP&_r=1",
    },
    {
      label: "Facebook",
      url: "https://www.facebook.com/share/8EhXNFrXNoq7X9Jc/?mibextid=LQQJ4d",
    },
    {
      label: "Instagram",
      url: "https://www.instagram.com/chickk.cheek?igsh=ZmNhNmp5bDRjbmtn",
    },
    { label: "Line", url: "https://lin.ee/iRaPomW" },
  ];

  const onlineStore = [
    {
      img: `${ImgGrab}`,
      label: "Grab",
      link: "https://r.grab.com/g/6-20250103_194130_F159A64D660C4CCA9535DF89DC8420BC_MEXMPS-3-C6WTT4KFT3TDME",
    },
    {
      img: `${ImgLineman}`,
      label: "Lineman",
      link: "https://lin.ee/HDnoZ1e",
    },
    {
      img: `${ImgShopee}`,
      label: "Shopee Food",
      link: "https://shopee.co.th/universal-link/now-food/shop/10265971?deep_and_deferred=1&shareChannel=line",
    },
  ];
  return (
    <div
      className="link-tree"
      style={{
        backgroundImage: `url(${chickkcheek})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Image
        src={logo}
        style={{
          width: 150,
        }}
      />
      <h1 className="text-header">Chick'k Cheek</h1>

      {links.map((link, index) => (
        <a
          key={index}
          href={link.url}
          className="link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.label}
        </a>
      ))}

      <p className="store-text">ช่องทางการสั่งซื้อ</p>
      <div className="d-flex gap-2">
        {onlineStore.map((d, i) => (
          <span className="m-2">
            <a href={d.link} key={i}>
             
                <Image className="img-size" src={d.img} />
             
            </a>
          </span>
        ))}{" "}
      </div>
    </div>
  );
}

export default App;
